import { render, staticRenderFns } from "./bibliometric.vue?vue&type=template&id=3be0ece3&scoped=true&"
import script from "./bibliometric.vue?vue&type=script&lang=js&"
export * from "./bibliometric.vue?vue&type=script&lang=js&"
import style0 from "./bibliometric.vue?vue&type=style&index=0&id=3be0ece3&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3be0ece3",
  null
  
)

export default component.exports